import React from 'react';

function CookiePolicy() {
    return (
        <div className="bg-[#f3f3f3] pt-20 font-nunito min-h-screen">
            <h1>Cookie Policy</h1>
        </div>
    );
}

export default CookiePolicy;